import React from 'react';
import Swapers from '../../Carousel/Swapers/Swapers';
import './Gallery.css';
import { imgURL } from '../../Config';
import { Link } from 'react-router-dom';

const Gallery = ({ galleryData }) => {
  const renderGallerySlide = (image) => (
    <div className="item" key={image.id}>
      <div className="gallery-page__card">
        <img
          src={imgURL + image.thumbnail}
          alt={image.description}
        />
        <div className="gallery-page__card__hover">
          <Link to="/gallery" className="img-popup">
            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 15.0573H30.1147" stroke="white" strokeWidth="3" />
              <path d="M15.0586 0L15.0586 30.1149" stroke="white" strokeWidth="3" />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );

  return (
    <section className="gallery-page container-fluid">
      <div className="text-end">
        <Link to="/gallery">
          <button className="btn btn-sm btn-primary me-2">View all</button>
        </Link>
      </div>

      <div className="container">
        <div className="sec-title text-center pb-2">
          <h4 className="sec-title__tagline justify-content-center">Photo Gallery</h4>
        </div>

        {galleryData?.length > 1 ? (
          <div className="gallery-page__carousel owl-carousel owl-theme">
            <Swapers
              slidesData={galleryData}
              renderSlide={renderGallerySlide}
              slidesPerView={galleryData.length === 2 ? 2 : Math.min(galleryData.length, 4)}
              spaceBetween={20}
              loop={galleryData.length > 4}
              navigation
              pagination={{ clickable: true }}
              breakpoints={{
                0: { slidesPerView: 1 },
                576: { slidesPerView: galleryData.length === 2 ? 2 : 2 },
                992: { slidesPerView: galleryData.length > 2 ? 2 : 3 },
              }}
            />

          </div>
        ) : (
          galleryData?.length === 1 && (
            <div className="gallery-page__card single-image">
              <img
                src={imgURL + galleryData[0].thumbnail}
                alt={galleryData[0].description}
              />
            </div>
          )
        )}
      </div>
    </section>
  );
};

export default Gallery;
